import { Command } from "@ckeditor/ckeditor5-core";

export default class InsertEdithDivCommand extends Command {
    execute() {
        const editor = this.editor;

        editor.model.change((writer) => {
            const divHtml = '<p class="hidep"></p><div><p>Insérer du contenu</p></div><p class="hidep"></p>';
            const viewFragment = editor.data.processor.toView(divHtml);
            const modelFragment = editor.data.toModel(viewFragment);

            editor.model.insertContent(modelFragment);
        });
    }

    refresh() {
        this.isEnabled = true;
    }
}
